import { render, staticRenderFns } from "./StoreParams.vue?vue&type=template&id=2b0c19e4&scoped=true&"
import script from "./StoreParams.vue?vue&type=script&lang=ts&"
export * from "./StoreParams.vue?vue&type=script&lang=ts&"
import style0 from "./StoreParams.vue?vue&type=style&index=0&id=2b0c19e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c19e4",
  null
  
)

export default component.exports